import React from "react";
import { gql } from "@apollo/client";
import { useSnackbar } from "notistack";
import useCopy from "@react-hook/copy";
import { InstrumentType } from "@syos-music/instruments";
import { useIntl } from "react-intl";

import { Divider } from "@mui/material";

function getInfosText(intl, order, soundShaping) {
  const {
    instrument,
    instrumentType,
    name: mouthpieceName,

    legacyMouthpiece,
  } = soundShaping.mouthpieceRef;

  const texts = [InstrumentType.asString(intl, instrument, instrumentType)];

  if (legacyMouthpiece) {
    const params = legacyMouthpiece.params;
    const striationsText = !!parseInt(params.striations, 10)
      ? "x" + params.striations
      : "";

    texts.push(
      `${params.baffle}${params.chamber}${striationsText}`,
      `${params.tipOpening}${params.tableFacing}`
    );
  } else {
    texts.push(...mouthpieceName.split(" "));
  }

  let design = "";
  switch (soundShaping.designType) {
    case "catalog":
      design = soundShaping.designCatalog;
      break;

    case "originals":
      design = soundShaping.designOriginals;
      break;

    case "signature":
      design = soundShaping.designSignature?.signature ?? "";
      break;

    case "text":
      design = "text";
      break;

    default:
      break;
  }

  return [
    ...texts,
    design,
    order.user.profile.fullName,
    `https://lapidou.syos.co/orders/${order.id}`,
  ].join("\t");
}

export default function SoundShapingCopyInfos({
  order,
  soundShaping,
  children,
}) {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const text = React.useMemo(
    () => getInfosText(intl, order, soundShaping),
    [intl, order, soundShaping]
  );

  const { copy } = useCopy(text);

  const notifyCopy = React.useCallback(() => {
    copy();
    enqueueSnackbar(
      <span>
        Texte copié&nbsp;!
        <Divider sx={{ mt: 1, mb: 1, borderColor: "currentColor" }} />
        <code>{text}</code>
      </span>
    );
  }, [enqueueSnackbar, copy, text]);

  return children({ copy: notifyCopy });
}

SoundShapingCopyInfos.fragments = {
  order: gql`
    fragment Orders_OrderSidebarSoundShaping_CopyInfos_Order on Order {
      id

      user {
        id

        profile {
          fullName
        }
      }
    }
  `,
  soundShaping: gql`
    fragment Orders_OrderSidebarSoundShaping_CopyInfos_SoundShaping on SoundShaping {
      id
      designType
      designCatalog
      designSignature {
        id
        signature
      }

      mouthpieceRef {
        id
        instrument
        instrumentType
        name

        legacyMouthpiece {
          id

          params {
            striations
            baffle
            chamber
            tipOpening
            tableFacing
          }
        }
      }
    }
  `,
};
